// Main JavaScript file
console.log('🚀 App loaded!');

// Import web components
import './components/ad-widget.js';

// Show hot reload indicator
function showHotReloadIndicator() {
  const indicator = document.createElement('div');
  indicator.className = 'hot-reload-indicator';
  indicator.textContent = '🔌 Live Reload Connected';
  
  // Use requestAnimationFrame to prevent layout shift
  requestAnimationFrame(() => {
    document.body.appendChild(indicator);
    
    setTimeout(() => {
      requestAnimationFrame(() => {
        indicator.style.opacity = '0';
        indicator.style.transition = 'opacity 0.5s ease';
        setTimeout(() => indicator.remove(), 500);
      });
    }, 3000);
  });
}

// Check if WebSocket is connected (hot reload active) - only in development
if (typeof WebSocket !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1')) {
  const ws = new WebSocket(`ws://${location.host}/ws`);
  
  ws.onopen = () => {
    console.log('🔌 Live reload connected');
    showHotReloadIndicator();
  };
  
  ws.onmessage = () => {
    console.log('🔄 Reloading page...');
    location.reload();
  };
  
  ws.onerror = () => {
    console.log('⚠️ Live reload disconnected');
  };
}

// Example: Add interactivity to cards - Only after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Use requestAnimationFrame to prevent layout shift
  requestAnimationFrame(() => {
    const cards = document.querySelectorAll('.card');
    
    cards.forEach((card, index) => {
      // Only add animation delay if body has 'loaded' class
      if (document.body.classList.contains('loaded')) {
        card.style.animationDelay = `${index * 0.1}s`;
      }
      
      // Add click handler
      card.addEventListener('click', (e) => {
        console.log('Card clicked:', card.querySelector('h3')?.textContent);
      });
    });

    // Mobile menu toggle
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const mainNav = document.querySelector('.main-nav');
    
    if (menuToggle && mainNav) {
      menuToggle.addEventListener('click', () => {
        // Use requestAnimationFrame for smooth transitions
        requestAnimationFrame(() => {
          mainNav.classList.toggle('active');
          menuToggle.classList.toggle('active');
        });
      });
    }
  });
});

// Export utilities
export const utils = {
  formatDate: (date) => new Intl.DateTimeFormat('en-US').format(date),
  capitalize: (str) => str.charAt(0).toUpperCase() + str.slice(1),
  debounce: (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  }
};
